export default {
    "brands": [{
            "id": 24,
            "name": "本田",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/14.png"
        },
        {
            "id": 26,
            "name": "宝马",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/15.png"
        },
        {
            "id": 30,
            "name": "标致",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/13.png"
        },
        {
            "id": 74,
            "name": "大众",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/1.png"
        },
        {
            "id": 104,
            "name": "丰田",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/3.png"
        },
        {
            "id": 105,
            "name": "福特",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/8.png"
        },
        {
            "id": 110,
            "name": "菲亚特",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/11.png"
        },
        {
            "id": 200,
            "name": "克莱斯勒",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/9.png"
        },
        {
            "id": 225,
            "name": "雷诺",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/10.png"
        },
        {
            "id": 250,
            "name": "名爵",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/20.png"
        },
        {
            "id": 287,
            "name": "奇瑞",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/26.png"
        },
        {
            "id": 296,
            "name": "荣威",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/19.png"
        },
        {
            "id": 375,
            "name": "现代",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/12.png"
        },
        {
            "id": 403,
            "name": "中华",
            "logo_url": "http://resources.shchengsh.com/uploads/images/brand/22.png"
        }
    ]
}